import {
  UtensilsCrossed,
  Coffee,
  Pizza,
  Sandwich,
  IceCream,
  Beef,
  Cherry,
  Croissant,
  CupSoda,
  Soup,
  Wine,
  Beer,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/lib/utils';

// Food-related location icons
export const LOCATION_ICONS: Record<string, LucideIcon> = {
  restaurant: UtensilsCrossed,
  coffee: Coffee,
  pizza: Pizza,
  sandwich: Sandwich,
  icecream: IceCream,
  steak: Beef,
  dessert: Cherry,
  bakery: Croissant,
  drinks: CupSoda,
  soup: Soup,
  wine: Wine,
  beer: Beer,
};

export type LocationIconName = keyof typeof LOCATION_ICONS;

interface LocationIconProps {
  icon?: string | null;
  imageUrl?: string | null;
  isActive?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-12 w-12',
  lg: 'h-16 w-16',
};

const iconSizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

export function LocationIcon({
  icon,
  imageUrl,
  isActive = true,
  size = 'md',
  className,
}: LocationIconProps) {
  const containerClass = cn(
    'flex items-center justify-center rounded-xl overflow-hidden',
    sizeClasses[size],
    !isActive && 'opacity-50',
    className
  );

  // Custom uploaded image takes priority
  if (imageUrl) {
    return (
      <div className={containerClass}>
        <img
          src={imageUrl}
          alt="Location"
          className="h-full w-full object-cover"
        />
      </div>
    );
  }

  // Selected icon from picker - default to restaurant
  const IconComponent = icon && LOCATION_ICONS[icon] ? LOCATION_ICONS[icon] : UtensilsCrossed;

  return (
    <div className={cn(containerClass, 'bg-primary/10')}>
      <IconComponent className={cn(iconSizeClasses[size], 'text-primary')} />
    </div>
  );
}
